<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M4 10a6 6 0 0 1 9.97-4.5h-1.22a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75v-3a.75.75 0 0 0-1.5 0v1.16a7.5 7.5 0 1 0 2.5 5.31.75.75 0 0 0-1.5.06V10a6 6 0 0 1-12 0Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M4 10a6 6 0 0 1 10.47-4H12.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0v1.6a7 7 0 1 0 1.98 4.36.5.5 0 1 0-1 .08L16 10a6 6 0 0 1-12 0Z"
    />
  </svg>
</template>
